import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-order-sumamary',
  templateUrl: './order-sumamary.component.html',
  styleUrl: './order-sumamary.component.scss'
})
export class OrderSumamaryComponent {

  orderids: any;
    orderListDetailsImageUrl = environment.ImageBaseUrl;
    ordesDeails: any;
  prepaidamount: any;
  constructor( private api:ApiServiceService ,
    private Router:Router, private route:ActivatedRoute
  ){

    // this.activeRouter.params.subscribe((orderId : any)=>{
    //   const id = orderId['_id'];
    //   console.log('id' , id)
    //   this.getOrderById(id);
    // })

    const orderId = this.route.snapshot.queryParamMap.get('id');
  console.log('Order ID:', orderId);
    this.getOrderById(orderId);
  }
  // ngOninit(){
  //   this.getCartList()
  // }

  getOrderById(id: any){
    this.api.getOrderById(id).subscribe((res: any)=>{
      this.ordesDeails = res.data;
      console.log('ordesDeails---' , this.ordesDeails)
      this.orderids = this.ordesDeails.items;
      console.log('thisorderid' , this.orderids)
    },(error)=>{
      console.log('error', error)
    })
}


gotoTrackingOrder(){
this.Router.navigate(['profile-details', { pageName: 'myorder' }]);
}

 
}
